// extracted by mini-css-extract-plugin
export default {"dataItem":"styles_data-item__-2T28","dataItemKey":"styles_data-item-key__13cw8","dataItemValue":"styles_data-item-value__yKDU4"};